import { render, staticRenderFns } from "./cEssence.vue?vue&type=template&id=04bb1764&scoped=true&"
import script from "./cEssence.vue?vue&type=script&lang=js&"
export * from "./cEssence.vue?vue&type=script&lang=js&"
import style0 from "./cEssence.vue?vue&type=style&index=0&id=04bb1764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb1764",
  null
  
)

export default component.exports